module.exports = __webpack_public_path__ + "img/balkon.9ecd7855.jpg";